<template>
<div class="delivery-trail">
    <div id="mapContainer" :style="{'height': clientHeight + 'px', 'width': clientWidth + 'px'}"></div>
    <div id="driving_way" :class="{hide: (!isDeliveryList || isWarehouseSend)}">
        <el-select v-model="routePolicyIndex" placeholder="请选择驾车策略">
            <el-option
            v-for="(item, index) in routePolicyArr"
            :key="index"
            :label="item.name"
            :value="index">
            </el-option>
        </el-select>
        <el-button @click="findTrail">查询</el-button>
    </div>
    <el-table v-if="this.$route.query.oid" key="1" height="300" :data="tableData" border style="width: 100%;" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
        <el-table-column  prop="transport_duration" align="center" label="配送时长" min-width="9%">
        </el-table-column>
        <el-table-column prop="num" label="订单号" align="center" min-width="11%">
        </el-table-column>
        <el-table-column prop="transport_express_user_name" align="center" label="配送员" min-width="9%">
        </el-table-column>
        <el-table-column prop="transport_express_user_phone" align="center" label="电话" min-width="9%">
        </el-table-column>
        <el-table-column prop="transport_status_name" align="center" label="配送状态" min-width="9%">
        </el-table-column>
        <el-table-column prop="order_seller_address" align="center" label="发货地" min-width="20%">
        </el-table-column>
        <el-table-column prop="order_address" label="终点" align="center" min-width="20%">
        </el-table-column>
        <el-table-column prop="transport_distance" align="center" label="配送距离" min-width="9%">
        </el-table-column>
    </el-table>
    <el-table v-else key="2" :data="tableData" border height="300" style="width: 100%; " :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
        <el-table-column  prop="duration" align="center" label="配送时长" min-width="9%">
        </el-table-column>
        <el-table-column prop="order_num" label="订单号" align="center" min-width="11%">
        </el-table-column>
        <el-table-column prop="transport_express_user" align="center" label="配送员" min-width="9%">
        </el-table-column>
        <el-table-column prop="express_user_phone" align="center" label="电话" min-width="9%">
        </el-table-column>
        <el-table-column prop="transport_status_name" align="center" label="配送状态" min-width="9%">
        </el-table-column>
        <el-table-column prop="send_address" align="center" label="发货地" min-width="20%">
        </el-table-column>
        <el-table-column prop="buyer" label="终点" align="center" min-width="20%">
        </el-table-column>
        <el-table-column prop="transport_distance" align="center" label="配送距离" min-width="9%">
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="9%">
            <template slot-scope="scope">
                 <el-button type="text" size="small" @click="checkDeliveryTrail(scope.row)">查看轨迹</el-button>
            </template>
        </el-table-column>
    </el-table>
</div>
</template>

<script>
import {mapGetters} from 'vuex';
export default {
    data() {
        return {
            isWarehouseSend: false,
            isDeliveryList: false,
            clientHeight: '',
            clientWidth: '',
            start: '',
            end: '',
            user: {},
            userTypeNum: '',
            globalMap: null,
            lushu: null,
            routePolicyIndex: 0,
            tableData: [],
            trailArr: [],
            arrPois: [],
            routePolicy: [],
            routePolicyArr: [
                {
                    name: '最少时间',
                    id: 0
                },
                {
                    name: '最短距离',
                    id: 1
                },
                {
                    name: '避开高速',
                    id: 2
                }
            ]
        }
    },
    computed: {
        // ...mapGetters(['user', 'userTypeNum'])
    },
    created() {
        if(this.$route.query.user) {
            this.user = JSON.parse(this.$route.query.user)
        }
        else {
            this.user = this.$store.state.user;
        }
        this.userTypeNum = this.user.user_type.user_type_num;
        this.clientWidth = document.documentElement.clientWidth;
        this.clientHeight = document.documentElement.clientHeight - 360;
    },
    mounted() {
        this.init();
    },
    methods: {
        changeTableHeaderStyle({row, rowIndex}) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle ({row, column, rowIndex, columnIndex}) {
            if(columnIndex == 5) {
                if(row.status_num == -1) {
                    return 'color: #FF3333;'
                }
                else if(row.status_num == 0) {
                    return 'color: #29bd7f;'
                }
                else if(row.status_num == 1) {
                    return 'color: #e6a23c;'
                }
            }
            return 'color: #000;'
        },
        init() {
            if(this.$route.query.oid) {
                this.isDeliveryList = true;
                console.log('DeliveryList')
                if(this.$route.query.isFeiYou == 'yes'){
                    this.isWarehouseSend = false;
                    this.getFeiYouDeliveryTrail(this.$route.query.oid, (res) => {
                        console.log('getDeliveryTrail');
                        if(!res.data.data) {
                            this.$message({
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                        this.tableData.push(res.data.data);
                        this.trailArr = res.data.data.trail;
                        this.mapInit();
                    })
                }
                else if(this.$route.query.isWarehouseSend) {
                    this.isWarehouseSend = false;
                    this.axios.get('address_location', {
                        params: {
                            oid: this.$route.query.oid
                        }
                    })
                    .then(res => {
                        if(!res.data.data) {
                            this.$message({
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                        this.tableData.push(res.data.data);
                        this.getDriveTrail(res.data.data.order_seller_address, res.data.data.order_address);
                        this.findTrail();
                    })
                }
                else {
                    this.isWarehouseSend = true;
                    this.getDeliveryTrail(this.$route.query.oid, (res) => {
                        console.log('getDeliveryTrail');
                        if(!res.data.data) {
                            this.$message({
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                        this.tableData.push(res.data.data);
                        this.trailArr = res.data.data.trail;
                        this.mapInit();
                    })
                }
            }
            else {
                console.log('NoDeliveryList');
                this.isDeliveryList = false;
                this.isWarehouseSend = true;
                if(this.userTypeNum == 0 || this.userTypeNum == 1) {
                    this.getDeliveryList(this.user.id, (res) => {
                        console.log('getDeliveryList')
                        this.tableData = res.data.data;
                        this.checkDeliveryTrail(res.data.data[0], res => {
                            if(res.data.msg == '该订单目前无配送轨迹') {
                                this.$message.error('该订单目前无配送轨迹 !');
                                this.globalMap = new BMap.Map("mapContainer");
                                this.globalMap.centerAndZoom(new BMap.Point(108.957395, 34.265803), 15);
                                this.globalMap.enableScrollWheelZoom(true);
                            }
                            else {
                                this.trailArr = res.data.data.trail;
                                this.mapInit();
                            }
                        });
                    })
                }
            }
            
        },
        getDriveTrail(start, end) {
            // 百度地图API功能
            this.globalMap = new BMap.Map("mapContainer");
            this.start = start
            this.end = end
            // this.end = '陕西省渭南市临渭区滨河大道'
            this.globalMap.centerAndZoom(new BMap.Point(116.404, 39.915), 11);
            //三种驾车策略：最少时间，最短距离，避开高速
            this.routePolicy = [BMAP_DRIVING_POLICY_LEAST_TIME,BMAP_DRIVING_POLICY_LEAST_DISTANCE,BMAP_DRIVING_POLICY_AVOID_HIGHWAYS];
        },
        findTrail() {
            this.globalMap.clearOverlays(); 
            this.search(this.start,this.end,this.routePolicy[this.routePolicyIndex]); 
        },
        search(start, end, route) {
            var driving = new BMap.DrivingRoute(this.globalMap, {renderOptions:{map: this.globalMap, autoViewport: true},policy: route});
            driving.search(start,end);
        },
        getFeiYouDeliveryTrail(oid, cb) {
            this.axios.get('station_transport_trail', {
                params: {
                    oid: oid
                }
            })
            .then(res => {
                if((typeof cb) == 'function') {
                    cb(res);
                }
            })
        },
        getDeliveryTrail(oid, cb) {
            this.axios.get('transport_trail', {
                params: {
                    oid: oid
                }
            })
            .then(res => {
                if((typeof cb) == 'function') {
                    cb(res);
                }
            })
        },
        getDeliveryList(uid, cb) {
            this.axios.get('trail_board', {
                params: {
                    user_id: uid
                }
            }).then(res => {
                if((typeof cb) == 'function') {
                    cb(res);
                }
            })
        },
        checkDeliveryTrail(rowData, cb) {
            // alert(11)
            this.getDeliveryTrail(rowData.oid, res => {
                if((typeof cb) == 'function') {
                    cb(res);
                }
                else {
                    this.globalMap.clearOverlays();
                    if(res.data.msg == '该订单目前无配送轨迹') {
                        this.$message.error('该订单目前无配送轨迹 !');
                    }
                    this.trailArr = res.data.data.trail;
                    this.arrPois.splice(0,this.arrPois.length);
                    for (let i = 0, len = this.trailArr.length; i < len; i++) {
                        console.log('trailArr: ', this.trailArr);
                        this.arrPois.push(this.bd_encrypt(this.trailArr[i].lon, this.trailArr[i].lat))
                    }
                    this.luShuInit();
                    this.lushuStart();
                }
            })
        },
        mapInit() {
            console.log('mapInit')
            this.globalMap = new BMap.Map("mapContainer");
            this.globalMap.centerAndZoom(new BMap.Point(108.957395, 34.265803), 15);
            this.globalMap.enableScrollWheelZoom(true);
            this.luShuInit();
            for (let i = 0, len = this.trailArr.length; i < len; i++) {
                this.arrPois.push(this.bd_encrypt(this.trailArr[i].lon, this.trailArr[i].lat))
            }
            this.lushuStart();
        },
        luShuInit() {
            console.log('luShuInit')
            BMapLib.LuShu.prototype._move = function (initPos, targetPos, effect) {
                var pointsArr = [initPos, targetPos]; //点数组
                var me = this,
                    //当前的帧数
                    currentCount = 0,
                    //步长，米/秒
                    // timer = 10,
                    timer = 1,
                    step = this._opts.speed / (300 / timer),
                    //初始坐标
                    init_pos = this._projection.lngLatToPoint(initPos),
                    //获取结束点的(x,y)坐标
                    target_pos = this._projection.lngLatToPoint(targetPos),
                    //总的步长
                    count = Math.round(me._getDistance(init_pos, target_pos) / step);
                //显示折线 syj201607191107
                this._map.addOverlay(new BMap.Polyline(pointsArr, {
                    strokeColor: "#111",
                    strokeWeight: 5,
                    strokeOpacity: 0.5
                })); // 画线 
                //如果小于1直接移动到下一点
                if (count < 1) {
                    me._moveNext(++me.i);
                    return;
                }
                me._intervalFlag = setInterval(function () {
                    //两点之间当前帧数大于总帧数的时候，则说明已经完成移动
                    if (currentCount >= count) {
                        clearInterval(me._intervalFlag);
                        //移动的点已经超过总的长度
                        if (me.i > me._path.length) {
                            return;
                        }
                        //运行下一个点
                        me._moveNext(++me.i);
                    } else {
                        currentCount++;
                        var x = effect(init_pos.x, target_pos.x, currentCount, count),
                            y = effect(init_pos.y, target_pos.y, currentCount, count),
                            pos = me._projection.pointToLngLat(new BMap.Pixel(x, y));
                        //设置marker
                        if (currentCount == 1) {
                            var proPos = null;
                            if (me.i - 1 >= 0) {
                                proPos = me._path[me.i - 1];
                            }
                            if (me._opts.enableRotation == true) {
                                me.setRotation(proPos, initPos, targetPos);
                            }
                            if (me._opts.autoView) {
                                if (!me._map.getBounds().containsPoint(pos)) {
                                    me._map.setCenter(pos);
                                }
                            }
                        }
                        //正在移动
                        me._marker.setPosition(pos);
                        //设置自定义overlay的位置
                        me._setInfoWin(pos);
                    }
                }, timer);
            };
        },
        bd_encrypt(gaodeLon, gaodeLat) {
            var X_PI = Math.PI * 3000.0 / 180.0;
            var x = gaodeLon,
                y = gaodeLat;
            var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
            var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
            var bd_lon = z * Math.cos(theta) + 0.0065;
            var bd_lat = z * Math.sin(theta) + 0.006;
            let point = new BMap.Point(bd_lon, bd_lat);
            return point;
        },
        lushuStart() {
            console.log('lushuStart')
            console.log('arrPois: ', this.arrPois);
            this.globalMap.centerAndZoom(this.arrPois[0], 15);
            this.lushu = new BMapLib.LuShu(this.globalMap, this.arrPois, {
                autoView: true, //是否开启自动视野调整，如果开启那么路书在运动过程中会根据视野自动调整
                icon: new BMap.Icon('http://developer.baidu.com/map/jsdemo/img/car.png', new BMap.Size(52, 26), {
                    anchor: new BMap.Size(27, 13)
                }),
                speed: 4500,
                enableRotation: true, //是否设置marker随着道路的走向进行旋转
                landmarkPois: [{
                    lng: 116.306954,
                    lat: 40.05718,
                    html: '加油站',
                    pauseTime: 2
                }]
            });
            this.lushu.start();
            console.log('lushu.start.end')
        }
    }
}
</script>

<style scoped>
.hide {
    display: none !important;
}
.delivery-trail {
    position: relative;
}
#driving_way  {
    position: absolute;
    top: 20px;
    left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/dataBoard/DeliveryTrail.vue